import { Stack } from "@mui/material";
import { forwardRef } from "react";
import { cn } from "utils/styling";

type BouncingDot = {
  delayClassName: string;
  name: string;
};

type BouncingDotsProps = {
  className?: string;
  dotClassName?: string;
};

const DOTS: BouncingDot[] = [
  { delayClassName: "[animation-delay:-0.3s]", name: "left" },
  { delayClassName: "[animation-delay:-0.15s]", name: "middle" },
  { delayClassName: "", name: "right" },
];

export const BouncingDots = forwardRef<HTMLDivElement, BouncingDotsProps>(function BouncingDots(
  { className, dotClassName },
  ref
) {
  return (
    <Stack className={cn("gap-1.5", className)} ref={ref}>
      {DOTS.map((dot) => (
        <span
          className={cn(
            "h-1.5 w-1.5 animate-bounce rounded-full bg-lds-foreground-inverse",
            dot.delayClassName,
            dotClassName
          )}
          key={dot.name}
        />
      ))}
    </Stack>
  );
});
